import { render } from "./PuxDropdown.pug?vue&type=template&id=b08ac9fa&lang=pug"
import script from "./PuxDropdown.js?vue&type=script&lang=js"
export * from "./PuxDropdown.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__